import React from 'react';
import { Link } from 'react-router-dom';
import css from './VideoCard.module.css';

function VideoCard({ post }) {
    const formattedDate = post.created_at
        ? new Date(post.created_at).toLocaleDateString('uz-UZ')
        : '';

    return (
        <div className={css.card}>
            <div className={css.videoWrapper}>
                <video
                    src={post.url}
                    preload="none"
                    className={css.video}
                />
                <Link to={'/video/' + post.id} className={css.overlay}>
                    <div className={css.playBtn}>
                        <i className="bi bi-play-fill"></i>
                    </div>
                </Link>
                {post.category && (
                    <span className={css.categoryBadge}>{post.category}</span>
                )}
            </div>
            <div className={css.body}>
                <p className={css.title}>{post.name}</p>
                <div className={css.footer}>
                    <span className={css.date}>{formattedDate}</span>
                    <Link to={'/video/' + post.id} className={css.watchBtn}>
                        Ko'rish <i className="bi bi-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default VideoCard;